/**
 * TicketedEventCustomQuestion Entity Schemas
 *
 * Per-event custom registration questions. Answers are snapshotted onto the
 * Order at submission time so historical orders remain readable after edits.
 */

import { z } from 'zod'
import { TicketedEventCustomQuestionTypeSchema } from './ticketed-event-order'

export const TicketedEventCustomQuestionSchema = z.object({
  id: z.string(),
  prompt: z.string(),
  type: TicketedEventCustomQuestionTypeSchema,
  required: z.boolean(),
  options: z.array(z.string()).nullable(),
  sortOrder: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string().nullable()
})
export type TicketedEventCustomQuestion = z.infer<typeof TicketedEventCustomQuestionSchema>

export const TicketedEventCustomQuestionPublicSchema = z.object({
  id: z.string(),
  prompt: z.string(),
  type: TicketedEventCustomQuestionTypeSchema,
  required: z.boolean(),
  options: z.array(z.string()).nullable(),
  sortOrder: z.number().int()
})
export type TicketedEventCustomQuestionPublic = z.infer<typeof TicketedEventCustomQuestionPublicSchema>
